import { SortingColumn } from '../../../../utils/sorting';
import { SortingDirection } from '../../../../utils/types/SortingDirection';
import { QueryParam, getQueryParam } from '../../../../utils/url';

export const SORTING_COLUMN_NAME_QUERY_PARAM = 'sorting_column';
export const SORTING_DIRECTION_QUERY_PARAM = 'sorting_direction';

function defaultSortingColumn(): string {
  return 'days_on_stage';
}

function defaultSortingDirection(): SortingDirection {
  return 'desc';
}

export function parseSortingColumn(): SortingColumn {
  return {
    columnName: parseSortingColumnName(),
    direction: parseSortingDirection(),
  };
}

export function parseSortingColumnName(): string {
  const value = getQueryParam(SORTING_COLUMN_NAME_QUERY_PARAM);

  if (value != null) return value;

  return defaultSortingColumn();
}

export function parseSortingDirection(): SortingDirection {
  const value = getQueryParam(SORTING_DIRECTION_QUERY_PARAM);

  if (value == null) return defaultSortingDirection();

  const parsedSortingDirection: SortingDirection = value as SortingDirection;

  if (parsedSortingDirection != null) return parsedSortingDirection;

  return defaultSortingDirection();
}

export function mapSortingColumnToQueryParam(value: string): QueryParam {
  return {
    key: SORTING_COLUMN_NAME_QUERY_PARAM,
    value: value,
  };
}

export function mapSortingDirectionToQueryParam(
  value: SortingDirection,
): QueryParam {
  return {
    key: SORTING_DIRECTION_QUERY_PARAM,
    value: value.toString(),
  };
}
